import { Box } from "@mui/material";
import { CollapseButton, MobileSidebar, SideBar } from "./Containers/Sidebar";
import { Outlet } from "react-router-dom";
import { Fragment } from "react";
import { useHome } from "./Hooks";
import { SIDEBAR_WIDTH, UI_ELEMENTS } from "Common/Constants";
import { Snackbar } from "Common/Components";

export const Home = () => {
  const {
    matchDownMd,
    drawer,
    setDrawer,
    isCollapsed,
    setIsCollapsed,
    isInsideCollapsed,
    setIsInsideCollapsed,
    uiElementState,
    handleCloseUIElement,
    setUIElementState,
  } = useHome();

  return (
    <Fragment>
      <Box
        sx={() => ({
          display: "flex",
          height: "100%",
          width: "100%",
          position: "relative",
        })}
      >
        {matchDownMd ? (
          <CollapseButton
            isCollapsed={isCollapsed}
            onClick={() => {
              setDrawer(!drawer);
              setIsCollapsed(!isCollapsed);
            }}
            sx={{
              backgroundColor: isCollapsed ? "none" : "white",
              left: isCollapsed ? 0 : SIDEBAR_WIDTH,
              top: "calc(50% - 48px)",
              transform: "translate(0%, -50%)",
            }}
          />
        ) : (
          <SideBar
            isCollapsed={isInsideCollapsed}
            setIsCollapsed={setIsInsideCollapsed}
            setUIElementState={setUIElementState}
            handleCloseUIElement={handleCloseUIElement}
            uiElementState={uiElementState}
          />
        )}
        <Box
          sx={(theme) => ({
            height: "100%",
            [theme.breakpoints.up("md")]: {
              width: isInsideCollapsed ? "100%" : `calc(100% - ${SIDEBAR_WIDTH}px)`,
              transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
              ...(isCollapsed && {
                transition: theme.transitions.create("width", {
                  easing: theme.transitions.easing.easeOut,
                  duration: theme.transitions.duration.leavingScreen,
                }),
              }),
            },
            backgroundColor: theme.palette.common.white,
            [theme.breakpoints.down("md")]: {
              width: "100%",
            },
            display: "block",
            borderLeft: isInsideCollapsed ? "none" : `1px solid ${theme.palette.grey[200]}`,
          })}
        >
          <Outlet />
        </Box>
      </Box>

      <Snackbar
        open={uiElementState.activeElement === UI_ELEMENTS.SNACKBAR}
        handleClose={handleCloseUIElement}
        message={uiElementState.snackbarMessage}
        severity={uiElementState.snackbarSeverity}
      />

      {matchDownMd && (
        <MobileSidebar isOpen={drawer}>
          <SideBar
            setUIElementState={setUIElementState}
            handleCloseUIElement={handleCloseUIElement}
            uiElementState={uiElementState}
          />
        </MobileSidebar>
      )}
    </Fragment>
  );
};
